import {vnModule} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule";
import {vnAppZone} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";

import {home} from "./home";
import {menu_mod} from "./menu";
import {header} from "./header";
import {login} from "./login";
import {users_edit} from "./users_edit";
import {users} from "./users";
import {logs} from "./logs";
import {tasks} from "./tasks";
import {tasks_edit} from "./tasks_edit";
import {searchQuery} from "./searchQuery";
import {reset_password} from "./reset_password";
import {data_import} from "./data_import";
import {gp_sheet} from "./gp_sheet";
import {loginStats} from "./loginStats";
import {users_profile} from "./users_profile";
import {dev_featurePoints} from "./dev_featurePoints";
import {roi_tool} from "./roi_tool";
import {editorialInsights} from "./editorialInsights";
import {platformStats_fbPage_post} from "./platformStats_fbPage_post";
import {platformStats_fbPage_postDaily} from "./platformStats_fbPage_postDaily";
import {platformStats_fbPage_postHourly} from "./platformStats_fbPage_postHourly";
import {updateComparison} from "./updateComparison";
import {roles} from "../../vendor/valnet/valnet_jslib/vnApp/roles";
import {roles_edit} from "../../vendor/valnet/valnet_jslib/vnApp/roles_edit";
import {roles_view} from "../../vendor/valnet/valnet_jslib/vnApp/roles_view";
import {goals} from "./goals";
import {goal_edit} from "./goal_edit";
import {goal_view} from "./goal_view";
import {networkGroups} from "./networkGroups";
import {networkGroup_edit} from "./networkGroup_edit";
import {networkGroup_view} from "./networkGroup_view";
import {newsletterPerformance} from "./newsletterPerformance";
import {initiativeModelReport} from "./initiativeModelReport";
import {monthlyInternalCost} from "./monthlyInternalCost";
import {txnInitSplit} from "./txnInitSplit";
import {txnInitSplit_edit} from "./txnInitSplit_edit";
import {txnInitSplit_view} from "./txnInitSplit_view";
import {facebookContentComparison} from "./facebookContentComparison";
import {affiliateRevenueReport} from "./affiliateRevenueReport";
import {carMarketplaceAffiliateReport} from "./carMarketplaceAffiliateReport";
import {googleOverview} from "./googleOverview";
import {googleOverviewArticle} from "./googleOverviewArticle";
import {speedTestReport} from "./speedTestReport";
import {speedTestInsightsDomainConfig} from "./speedTestInsightsDomainConfig";
import {speedTestInsightsDomainConfigEdit} from "./speedTestInsightsDomainConfigEdit";
import {speedTestInsightsLog} from "./speedTestInsightsLog";
import {speedTestCruxDomainConfig} from "./speedTestCruxDomainConfig";
import {speedTestCruxDomainConfigEdit} from "./speedTestCruxDomainConfigEdit";
import {speedTestAdsAuditDomainConfig} from "./speedTestAdsAuditDomainConfig";
import {speedTestAdsAuditDomainConfigEdit} from "./speedTestAdsAuditDomainConfigEdit";
import {speedTestAdsAuditLog} from "./speedTestAdsAuditLog";
import {featurePoints} from "./featurePoints";
import {featurePointsConfig_view} from "./featurePointsConfig_view";
import {featurePointsHolidays_edit} from "./featurePointsHolidays_edit";
import {featurePointsAssignee_edit} from "./featurePointsAssignee_edit";
import {topicalityReport} from "./topicalityReport";
import {tagPerformanceArticleReport} from "./tagPerformanceArticleReport";
import {articleSessionDiagnostics} from "./articleSessionDiagnostics";
import {articleRevenue} from "./articleRevenue";
import {jiraTask} from "./jiraTask";
import {videoPerformance} from "./videoPerformance";
import {contentInvestment} from "./contentInvestment";
import {segmentReport} from "./segmentReport";
import {articleAnalysis} from "./articleAnalysis";
import {heavyHitters} from "./heavyHitters";
import {leadgen} from "./leadgen";
import sensai_vault from "./sensAI_vault";
import {taskTree} from "./taskTree";
import {backfill} from "./backfill";
import {dspReport} from "./dspReport";
import {notFound} from "./notFound";

export class pageFactory{

        get_actionHandler(typeName :string, vnAppZone: vnAppZone) :vnModule{

            let obj :vnModule;
            console.log("Instantiating module ["+typeName+"]");

            switch (typeName)
            {
                case "home" :
                    obj = new articleAnalysis(vnAppZone);
                    break;
                case "menu" :
                    obj = new menu_mod(vnAppZone);
                    break;
                case "header" :
                    obj = new header(vnAppZone);
                    break;
                case "login" :
                    obj = new login(vnAppZone);
                    break;
                case "users" :
                    obj = new users(vnAppZone);
                    break;
                case "users_edit" :
                    obj = new users_edit(vnAppZone);
                    break;
                case "users_profile" :
                    obj = new users_profile(vnAppZone);
                    break;
                case "logs" :
                    obj = new logs(vnAppZone);
                    break;
                case "tasks" :
                    obj = new tasks(vnAppZone);
                    break;
                case "tasks_edit" :
                    obj = new tasks_edit(vnAppZone);
                    break;
                case "taskTree" :
                    obj = new taskTree(vnAppZone);
                    break;
                case "reset_password" :
                    obj = new reset_password(vnAppZone);
                    break;
                case "gp_sheet" :
                    obj = new gp_sheet(vnAppZone);
                    break;
                case "loginStats" :
                    obj = new loginStats(vnAppZone);
                    break;
                case "roles" :
                    obj = new roles(vnAppZone);
                    break;
                case "roles_edit" :
                    obj = new roles_edit(vnAppZone);
                    break;
                case "roles_view" :
                    obj = new roles_view(vnAppZone);
                    break;
                case "leadgen":
                    obj = new leadgen(vnAppZone);
                    break;
                case "articleAnalysis" :
                    obj = new articleAnalysis(vnAppZone);
                    break;
                case "newsletterPerformance" :
                    obj = new newsletterPerformance(vnAppZone);
                    break;
                case "contentInvestment" :
                    obj = new contentInvestment(vnAppZone);
                    break;
                case "editorialInsights" :
                    obj = new editorialInsights(vnAppZone);
                    break;
                case "articleRevenue" :
                    obj = new articleRevenue(vnAppZone);
                    break;
                default :
                    obj = new notFound(vnAppZone);
                    break;
            }

            return obj;
        }
    }



// WEBPACK FOOTER //
// ./js/modules/factory.ts